import cn from 'classnames';
import React from 'react';
import { Badge } from 'src/components/badge';
import { Text } from 'src/components/text/Text';
import { COUNTRY_BY_CURRENCY_MAP } from 'src/constants/country-by-currency-map';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';
import { useNextBillingDate } from 'src/hooks/use-next-billing-date';

import styles from './PayNextMonthTab.css';

export const PayNextMonthTab = () => {
  const t = useLocale();
  const { currency } = useAppContext();
  const country = COUNTRY_BY_CURRENCY_MAP[currency];
  const billingDate = useNextBillingDate();

  if (!billingDate) return null;

  return (
    <div className={styles.PayNextMonthTab} data-test="pay-next-month-tab">
      <div className={styles.PayNextMonthTab__Header}>
        <Text as="p" variant="body1Tight" data-test="pay-next-month-title">
          {t('pay_next_month')}
        </Text>
        <Badge textTestAttr="pay-next-month-badge">
          {t('no_down_payment')}
        </Badge>
      </div>
      <Text
        as="p"
        variant="body2Tight"
        className={cn(styles.PayNextMonthTab__Description, {
          [styles.PayNextMonthTab__Description_grey]: country === 'KSA',
        })}
        data-test="pay-next-month-description"
      >
        {t('no_interest_no_fees')}
      </Text>
      <Text
        as="p"
        variant="body2Tight"
        className={styles.PayNextMonthTab__Date}
        data-test="pay-next-month-date"
      >
        {t('pay_in_full_in_one_bill_due', {
          date: `${billingDate.day} ${billingDate.month}`,
        })}
      </Text>
    </div>
  );
};
